"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.Menu = {
  name: 'Menu',
  autoRoutes: ['list', 'create', 'update'],
  useCreator: true,
  table: {
    fieldNames: ["name", "items", "createdBy"],
    options: {
      items: {
        weight: 4
      }
    }
  },
  list: {
    banner: {
      content: 'Structure the {{MENUS}} for {{SITES}} based on the Platform.'
    },
    resultsVariant: 'list'
  },
  form: {
    modal: {
      maxWidth: "1000px"
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'json'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      items: {
        type: 'linkedTable',
        entityTypeName: 'MenuItem',
        description: "Specify the items inside this menu"
      },
      description: {
        type: 'description'
      },
      json: {
        type: 'json',
        description: 'As an alternative to using {{MENU_ITEMS}} to specify menu structure, create a JSON block for developers to parse instead.'
      }
    })
  }
};